export const footerMoreLinks = {
  'pk-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://www.wingie.pk/ar/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://www.wingie.pk/ar/faq/',
          title: 'الأسئلة المتكررة',
        },
        {
          href: 'https://www.wingie.pk/ar/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://www.wingie.pk/ar/privacy/',
          title: 'الخصوصية - وينجي',
        },
        {
          href: 'https://www.wingie.pk/ar/terms-and-conditions/',
          title: 'شروط الاستخدام',
        },
        {
          href: 'https://www.wingie.pk/ar/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'pk-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://www.wingie.pk/contact/',
          title: 'Contact',
        },
        {
          href: 'https://www.wingie.pk/faq/',
          title: 'Frequently Asked Questions',
        },
        {
          href: 'https://www.wingie.pk/about-us/',
          title: 'About us',
        },
        {
          href: 'https://www.wingie.pk/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://www.wingie.pk/terms-and-conditions/',
          title: 'Terms and Conditions',
        },
        {
          href: 'https://www.wingie.pk/awards/',
          title: 'Our Awards',
        },
      ],
    },
  ],
  'pk-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://www.wingie.pk/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://www.wingie.pk/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },
        {
          href: 'https://www.wingie.pk/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://www.wingie.pk/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://www.wingie.pk/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://www.wingie.pk/es/awards/',
          title: 'Nuestros premios',
        },
      ],
    },
  ],
  'pk-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://www.wingie.pk/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://www.wingie.pk/de/faq/',
          title: 'Häufig gestellte Fragen - Wingie',
        },
        {
          href: 'https://www.wingie.pk/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://www.wingie.pk/de/datenschutz/',
          title: 'Datenschutz & Cookies',
        },
        {
          href: 'https://www.wingie.pk/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://www.wingie.pk/de/awards/',
          title: 'Unsere Auszeichnungen',
        },
      ],
    },
  ],
  'pk-ru': [
    {
      title: 'более',
      items: [
        {
          href: 'https://www.wingie.pk/ru/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://www.wingie.pk/ru/faq/',
          title: 'Часто задаваемые вопросы',
        },
        {
          href: 'https://www.wingie.pk/ru/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://www.wingie.pk/ru/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://www.wingie.pk/ru/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://www.wingie.pk/ru/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'pk-it': [
    {
      title: 'Di più',
      items: [
        {
          href: 'https://www.wingie.pk/it/contact/',
          title: 'Contatto',
        },
        // {
        //     href: 'https://www.wingie.pk/it/faq/',
        //     title: 'Domande Frequenti',
        // },
        {
          href: 'https://www.wingie.pk/it/about-us/',
          title: 'Chi siamo',
        },
        {
          href: 'https://www.wingie.pk/it/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://www.wingie.pk/it/terms-and-conditions/',
          title: 'Termini e Condizioni',
        },
        {
          href: 'https://www.wingie.pk/it/awards/',
          title: 'I Nostri Premi',
        },
      ],
    },
  ],
  'pk-fr': [
    {
      title: 'Plus',
      items: [
        {
          href: 'https://www.wingie.pk/fr/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://www.wingie.pk/fr/faq/',
        //     title: 'Questions Fréquemment Posées',
        // },
        {
          href: 'https://www.wingie.pk/fr/about-us/',
          title: 'À propos de nous',
        },
        {
          href: 'https://www.wingie.pk/fr/privacy/',
          title: 'Confidentialité',
        },
        {
          href: 'https://www.wingie.pk/fr/terms-and-conditions/',
          title: 'Termes et Conditions',
        },
        {
          href: 'https://www.wingie.pk/fr/awards/',
          title: 'Nos Prix',
        },
      ],
    },
  ],
  'pk-pt': [
    {
      title: 'Mais',
      items: [
        {
          href: 'https://www.wingie.pk/pt/contact/',
          title: 'Contato',
        },
        // {
        //     href: 'https://www.wingie.pk/pt/faq/',
        //     title: 'Perguntas Frequentes',
        // },
        {
          href: 'https://www.wingie.pk/pt/about-us/',
          title: 'Sobre nós',
        },
        {
          href: 'https://www.wingie.pk/pt/privacy/',
          title: 'Privacidade',
        },
        {
          href: 'https://www.wingie.pk/pt/terms-and-conditions/',
          title: 'Termos e Condições',
        },
        {
          href: 'https://www.wingie.pk/pt/awards/',
          title: 'Nossos Prêmios',
        },
      ],
    },
  ],
  'pk-ro': [
    {
      title: 'Mai mult',
      items: [
        {
          href: 'https://www.wingie.pk/ro/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://www.wingie.pk/ro/faq/',
        //     title: 'Întrebări Frecvente',
        // },
        {
          href: 'https://www.wingie.pk/ro/about-us/',
          title: 'Despre noi',
        },
        {
          href: 'https://www.wingie.pk/ro/privacy/',
          title: 'Confidențialitate',
        },
        {
          href: 'https://www.wingie.pk/ro/terms-and-conditions/',
          title: 'Termeni și Condiții',
        },
        {
          href: 'https://www.wingie.pk/ro/awards/',
          title: 'Premiile Noastre',
        },
      ],
    },
  ],
  'pk-pl': [
    {
      title: 'Więcej',
      items: [
        {
          href: 'https://www.wingie.pk/pl/contact/',
          title: 'Kontakt',
        },
        // {
        //     href: 'https://www.wingie.pk/pl/faq/',
        //     title: 'Często Zadawane Pytania',
        // },
        {
          href: 'https://www.wingie.pk/pl/about-us/',
          title: 'O nas',
        },
        {
          href: 'https://www.wingie.pk/pl/privacy/',
          title: 'Prywatność',
        },
        {
          href: 'https://www.wingie.pk/pl/terms-and-conditions/',
          title: 'Warunki',
        },
        {
          href: 'https://www.wingie.pk/pl/awards/',
          title: 'Nasze Nagrody',
        },
      ],
    },
  ],
  'pk-lt': [
    {
      title: 'Daugiau',
      items: [
        {
          href: 'https://www.wingie.pk/lt/contact/',
          title: 'Kontaktai',
        },
        // {
        //     href: 'https://www.wingie.pk/lt/faq/',
        //     title: 'Dažnai Užduodami Klausimai',
        // },
        {
          href: 'https://www.wingie.pk/lt/about-us/',
          title: 'Apie mus',
        },
        {
          href: 'https://www.wingie.pk/lt/privacy/',
          title: 'Privatumas',
        },
        {
          href: 'https://www.wingie.pk/lt/terms-and-conditions/',
          title: 'Sąlygos',
        },
        {
          href: 'https://www.wingie.pk/lt/awards/',
          title: 'Mūsų Apdovanojimai',
        },
      ],
    },
  ],
  'pk-uz': [
    {
      title: "Ko'proq",
      items: [
        {
          href: 'https://www.wingie.pk/uz/contact/',
          title: 'Aloqa',
        },
        // {
        //     href: 'https://www.wingie.pk/uz/faq/',
        //     title: "Ko'p Beriladigan Savollar",
        // },
        {
          href: 'https://www.wingie.pk/uz/about-us/',
          title: 'Biz haqimizda',
        },
        {
          href: 'https://www.wingie.pk/uz/privacy/',
          title: 'Maxfiylik',
        },
        {
          href: 'https://www.wingie.pk/uz/terms-and-conditions/',
          title: 'Shartlar',
        },
        {
          href: 'https://www.wingie.pk/uz/awards/',
          title: 'Bizning mukofotlarimiz',
        },
      ],
    },
  ],
  'pk-sr': [
    {
      title: 'Више',
      items: [
        {
          href: 'https://www.wingie.pk/sr/contact/',
          title: 'Контакт',
        },
        // {
        //     href: 'https://www.wingie.pk/sr/faq/',
        //     title: 'Често Постављана Питања',
        // },
        {
          href: 'https://www.wingie.pk/sr/about-us/',
          title: 'О нама',
        },
        {
          href: 'https://www.wingie.pk/sr/privacy/',
          title: 'Приватност',
        },
        {
          href: 'https://www.wingie.pk/sr/terms-and-conditions/',
          title: 'Услови',
        },
        {
          href: 'https://www.wingie.pk/sr/awards/',
          title: 'Наше награде',
        },
      ],
    },
  ],
  'pk-ky': [
    {
      title: 'Дагы',
      items: [
        {
          href: 'https://www.wingie.pk/ky/contact/',
          title: 'Байланыш',
        },
        // {
        //     href: 'https://www.wingie.pk/ky/faq/',
        //     title: 'Көп берилген суроолор',
        // },
        {
          href: 'https://www.wingie.pk/ky/about-us/',
          title: 'Биз жөнүндө',
        },
        {
          href: 'https://www.wingie.pk/ky/privacy/',
          title: 'Купуялык',
        },
        {
          href: 'https://www.wingie.pk/ky/terms-and-conditions/',
          title: 'Шарттар',
        },
        {
          href: 'https://www.wingie.pk/ky/awards/',
          title: 'Биздин сыйлыктар',
        },
      ],
    },
  ],
  'pk-tg': [
    {
      title: 'Бештар',
      items: [
        {
          href: 'https://www.wingie.pk/tg/contact/',
          title: 'Тамос',
        },
        // {
        //     href: 'https://www.wingie.pk/tg/faq/',
        //     title: 'Саволҳои зиёд додашаванда',
        // },
        {
          href: 'https://www.wingie.pk/tg/about-us/',
          title: 'Дар бораи мо',
        },
        {
          href: 'https://www.wingie.pk/tg/privacy/',
          title: 'Махфият',
        },
        {
          href: 'https://www.wingie.pk/tg/terms-and-conditions/',
          title: 'Шартҳо',
        },
        {
          href: 'https://www.wingie.pk/tg/awards/',
          title: 'Ҷоизаҳои мо',
        },
      ],
    },
  ],
  'pk-kk': [
    {
      title: 'Көбірек',
      items: [
        {
          href: 'https://www.wingie.pk/kk/contact/',
          title: 'Байланыс',
        },
        // {
        //     href: 'https://www.wingie.pk/kk/faq/',
        //     title: 'Жиі қойылатын сұрақтар',
        // },
        {
          href: 'https://www.wingie.pk/kk/about-us/',
          title: 'Біз туралы',
        },
        {
          href: 'https://www.wingie.pk/kk/privacy/',
          title: 'Maxfiylik',
        },
        {
          href: 'https://www.wingie.pk/kk/terms-and-conditions/',
          title: 'Шарттар',
        },
        {
          href: 'https://www.wingie.pk/kk/awards/',
          title: 'Біздің марапаттар',
        },
      ],
    },
  ],
  'pk-nl': [
    {
      title: 'Meer',
      items: [
        {
          href: 'https://www.wingie.pk/nl/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://www.wingie.pk/nl/faq/',
        //     title: 'Veelgestelde Vragen',
        // },
        {
          href: 'https://www.wingie.pk/nl/about-us/',
          title: 'Over ons',
        },
        {
          href: 'https://www.wingie.pk/nl/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://www.wingie.pk/nl/terms-and-conditions/',
          title: 'Voorwaarden',
        },
        {
          href: 'https://www.wingie.pk/nl/awards/',
          title: 'Onze Prijzen',
        },
      ],
    },
  ],
  'pk-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://www.wingie.pk/ja/contact/' },
        { title: 'よくある質問', href: 'https://www.wingie.pk/en/faq/' },
        { title: '会社概要', href: 'https://www.wingie.pk/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://www.wingie.pk/ja/privacy/' },
        { title: '利用規約', href: 'https://www.wingie.pk/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://www.wingie.pk/ja/awards/' },
      ],
    },
  ],
  'pk-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://www.wingie.pk/zh/contact/' },
        { title: '常见问题', href: 'https://www.wingie.pk/en/faq/' },
        { title: '关于我们', href: 'https://www.wingie.pk/zh/about-us/' },
        { title: '隐私政策', href: 'https://www.wingie.pk/zh/privacy/' },
        { title: '条款和条件', href: 'https://www.wingie.pk/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://www.wingie.pk/zh/awards/' },
      ],
    },
  ],
  'pk-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://www.wingie.pk/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://www.wingie.pk/en/faq/' },
        { title: '회사 소개', href: 'https://www.wingie.pk/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://www.wingie.pk/ko/privacy/' },
        { title: '이용약관', href: 'https://www.wingie.pk/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://www.wingie.pk/ko/awards/' },
      ],
    },
  ],
  'pk-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://www.wingie.pk/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://www.wingie.pk/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://www.wingie.pk/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://www.wingie.pk/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://www.wingie.pk/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://www.wingie.pk/hi/awards/' },
      ],
    },
  ],
  'pk-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://www.wingie.pk/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://www.wingie.pk/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://www.wingie.pk/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://www.wingie.pk/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://www.wingie.pk/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://www.wingie.pk/ta/awards/' },
      ],
    },
  ],
  'pk-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://www.wingie.pk/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://www.wingie.pk/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://www.wingie.pk/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://www.wingie.pk/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://www.wingie.pk/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://www.wingie.pk/th/awards/' },
      ],
    },
  ],
  'pk-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://www.wingie.pk/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://www.wingie.pk/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://www.wingie.pk/ur/about-us/' },
        { title: 'رازداری', href: 'https://www.wingie.pk/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://www.wingie.pk/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://www.wingie.pk/ur/awards/' },
      ],
    },
  ],
  'pk-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://www.wingie.pk/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://www.wingie.pk/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://www.wingie.pk/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://www.wingie.pk/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://www.wingie.pk/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://www.wingie.pk/ka/awards/' },
      ],
    },
  ],
}
